/** @internal */
export enum AnimationType {
    CUT = 'CUT',
    FADE = 'FADE',
    ZOOM_IN = 'ZOOM_IN',
    ZOOM_OUT = 'ZOOM_OUT',
    SLIDE_UP = 'SLIDE_UP',
    SLIDE_DOWN = 'SLIDE_DOWN',
    SLIDE_RIGHT = 'SLIDE_RIGHT',
    SLIDE_LEFT = 'SLIDE_LEFT',
}

/** @internal */
export type DisabledAnimationConfig = { enabled: false }

/** @internal */
export type EnabledAnimationConfig = {
    enabled: true
    animations: AnimationType[]
    duration_milliseconds: number
}

/** @internal */
export type AnimationConfig = DisabledAnimationConfig | EnabledAnimationConfig

/** @internal */
export type AnimationCoordinator = {
    _animateIn(config: AnimationConfig, onComplete?: () => void): void
    _animateOut(config: AnimationConfig, onComplete?: () => void): void
}

/** @internal */
export enum AnimationStage {
    ENTRY = 'entry',
    EXIT = 'exit',
}

/** @internal */
export type AnimationTransform = {
    scaleX: number
    scaleY: number
    skewX: number
    skewY: number
    translateX: number
    translateY: number
}

/** @internal */
export type AnimationKeyframes = {
    to: Keyframe
    from: Keyframe
}
